import React, { Component } from "react";
import { MdSearch, MdInfo } from "react-icons/md";
import swal from "@sweetalert/with-react";
import io from "socket.io-client";
import jwt_decode from "jwt-decode";
import DefaultMoment from "moment";
const url = "https://transacoes-api.all.com.br:3080";

let value = "";

class SearchQuery extends Component {
  state = {
    idEmployeeLogged: "",
    placeholder: "Entre com a pesquisa...",
    transactions: [],
    disabled: true,
    hiddenSearch: true
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    await this.getUserLogged();
    if (this.refs.select.value === "-1") this.refs.search.disabled = true;
    this.getTransaction();
  }

  eventListenerSocket = () => {
    this.socket.on("data", () => {
      this.getTransaction();
      this.refs.select.value = "-1";
    });
  };

  getUserLogged = async () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      await this.setState({
        idEmployeeLogged: decoded.id.toString()
      });
    } else
      this.setState({
        idEmployeeLogged: ""
      });
  };

  getTransaction = () => {
    this.setState({ loading: true });
    fetch(`${url}/transacoes/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(transaction => {
        if (transaction.length > 0) {
          let filteredTransaction = transaction.filter(
            transaction => transaction.result !== 0
          );
          this.setState({
            transactions: filteredTransaction,
            loading: false
          });
        } else this.setState({ transactions: [], loading: false });
      });
  };

  showInformation = () => {
    swal({
      title: "Pesquisar por:",
      content: (
        <div>
          <h5>
            <p>
              <strong>Movimentações: </strong>
              ID malote, ID movimentação, remetente, destinatário, data/horário
              de criação e modificação, status.
            </p>
          </h5>
          <h5>
            <p>
              <strong>Itens: </strong>
              ID item, tipo, descrição, código/patrimônio, observação, status.
            </p>
          </h5>
          <br />
          <p>
            <strong>Observação: </strong>
            Malotes concluídos serão exibidos em um intervalo de 7 dias a partir
            do seu registro.
          </p>
        </div>
      ),
      icon: "info"
    });
  };

  setEnableSearch = () => {
    if (this.refs.select.value !== "-1") this.setState({ hiddenSearch: false });
  };

  handleOption = option => {
    this.props.handleOption(option);
    if (option === "movements") {
      this.refs.movements.checked = true;
      this.refs.items.checked = false;
    }
    if (option === "items") {
      this.refs.items.checked = true;
      this.refs.movements.checked = false;
    }
  };

  setValue = e => {
    value = e;
    this.props.handleSearch(value);
  };

  setFilter = e => {
    this.props.handleSearch(value);
    this.props.handleFilter(e);
    this.setState({ disabled: false });
    this.setEnableSearch();
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="container"
          style={{
            position: "relative"
          }}
        >
          <div
            className="row justify-content-center"
            style={{ paddingTop: "25px" }}
          >
            <div className="col-12">
              <form
                className="box-search"
                style={{
                  backgroundColor: "none",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <center>
                  <div className="row">
                    <div className="col s12">
                      <label
                        id="select"
                        className="center"
                        htmlFor="select"
                        align="center"
                      >
                        &nbsp;Selecione o malote desejado:
                      </label>
                      <select
                        className="form-control"
                        ref="select"
                        align="center"
                        required
                        id="select"
                        onChange={e => this.setFilter(e.target.value)}
                        defaultValue="-1"
                        style={{
                          width: "50%",
                          display: "block",
                          marginTop: "-5px",
                          marginBottom: "10px"
                        }}
                      >
                        <option value="-1" disabled>
                          Malote...
                        </option>
                        {this.state.transactions.map((transaction, i) => (
                          <option key={i} value={transaction.id_transacao}>
                            MALOTE &nbsp;{transaction.id_transacao}&nbsp;-&nbsp;
                            {transaction.status === "ativa"
                              ? "ATIVO"
                              : transaction.status === "pendente"
                              ? "PENDENTE"
                              : "CONCLUÍDO"}
                            &nbsp; (
                            {DefaultMoment(
                              new Date(transaction.created_at)
                            ).format("DD/MM/YYYY")}
                            )
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </center>
              </form>
            </div>
            <div className="col-12" hidden={this.state.hiddenSearch}>
              <form
                className="box-search"
                style={{
                  backgroundColor: "none",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <div
                  className=" row align-items-center"
                  style={{
                    marginLeft: "0",
                    marginRight: "0"
                  }}
                >
                  <div className="col s12">
                    <input
                      disabled={this.state.disabled}
                      ref="search"
                      style={{ marginTop: "10px" }}
                      type="text"
                      required
                      onChange={e => this.setValue(e.target.value)}
                      placeholder="Entre com a pesquisa..."
                    />
                  </div>
                  <div className="col-auto" style={{ fontSize: "1.5rem" }}>
                    <MdSearch style={{ marginTop: "20px" }} />
                  </div>
                </div>
                <div
                  className="row justify-content-center"
                  style={{
                    marginLeft: "0",
                    marginRight: "0",
                    paddingTop: "25px"
                  }}
                >
                  <div className="col s12">
                    <div className="filters-query">
                      <div className="right">
                        <MdInfo
                          style={{ width: "1rem" }}
                          onClick={() => this.showInformation()}
                        />
                      </div>
                      <span>
                        <label htmlFor="movements_items">
                          Buscar por: &nbsp;
                        </label>
                      </span>
                      <span style={{ padding: "5px" }}>
                        <input
                          ref="movements"
                          type="checkbox"
                          defaultChecked={true}
                          defaultValue="movements"
                          id="movements"
                          name="movements"
                          onChange={e => this.handleOption(e.target.value)}
                        />
                        <label htmlFor="movements">Movimentação</label>
                      </span>
                      <span style={{ padding: "5px" }}>
                        <input
                          ref="items"
                          type="checkbox"
                          defaultChecked={false}
                          defaultValue="items"
                          id="items"
                          name="items"
                          onChange={e => this.handleOption(e.target.value)}
                        />
                        <label htmlFor="items">Item</label>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SearchQuery;
